import React from 'react';

// Unread marker (#271): a reply to one of your support tickets you haven't opened yet.
const RedDot = ({ style }) => (
  <span
    aria-label="새 답변"
    style={{
      display: 'inline-block',
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: '#FF3B30',
      flexShrink: 0,
      ...style,
    }}
  />
);

export default RedDot;
